//old working function

/**
 * Checks for duplicate keys within separate objects and on the same line in a JSON string
 * and throws an error if duplicates are found.
 *
 * @param {string} jsonString - The JSON string to be checked for duplicate keys.
 * @throws {string} Throws an error if duplicate keys are found, indicating the duplicate keys in the error message.
 */
export const checkDuplicateKeys = (jsonString) => {
  try {
    // Create a Map to store keys for each object
    const keysByObject = new Map()
    // console.log({ jsonString })
    // Split the JSON string into lines and process each line
    const lines = jsonString.split(/\n/) // Split by newline or comma
    // console.log({ lines })
    // Create a Set to keep track of keys within the current object
    let currentObjectKeys = new Set()

    // Initialize a variable to track the parent key
    let parentKey = null

    // Iterate through each line in the JSON string
    lines.forEach((line) => {
      // Trim leading and trailing spaces from the line
      line = line.trim()

      // Check if the line marks the start of an object
      if (line.endsWith(": {")) {
        // Clear the set of keys for the current object
        currentObjectKeys.clear()
      }

      // Check for key-value pairs within the object
      if (line.startsWith('"')) {
        // Extract the key using a regular expression
        // console.log({ line })

        const key = line.toLowerCase().match(/"([^"]+)":/)[1]

        // Check if the key is the same as the parent key
        if (parentKey && key === parentKey) {
          // Allow using the parent key within the same object
          currentObjectKeys.add(key)
        } else {
          // If the key is not in the current object's keys, add it; otherwise, throw an error
          if (currentObjectKeys.has(key)) {
            // throw `Same keys detected: <strong>${key}</strong>. Same keys are not allowed within the same object. Kindly remove or modify it.`
            throw "Duplicate keys were found in the json, Kindly remove or modify them."
          }
          currentObjectKeys.add(key)
        }

        // Store keys for each object using a unique object identifier (the line itself)
        keysByObject.set(line, currentObjectKeys)
      }

      // Check if the line marks the end of an object
      if (line === "},") {
        // Clear the set of keys for the current object
        currentObjectKeys.clear()
      } else {
        // Update the parentKey when a new object starts
        const objectStartMatch = line.match(/"([^"]+)": {/)
        if (objectStartMatch) {
          parentKey = objectStartMatch[1]
        }
      }
    })
  } catch (error) {
    console.error(error)
  }
}
